import { FC } from 'react';
import { Grid, Flex, Space, Text, List, UnstyledButton } from '@mantine/core';
import { ReactComponent as Twitter } from '../../assets/svg/twitter.svg';
import { ReactComponent as Linkedin } from '../../assets/svg/linkedin.svg';
import { ReactComponent as MailTo } from '../../assets/svg/mailTo.svg';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { footerRoutes } from 'src/constants';
import { SelectLanguage } from '@common/components';

import styles from './styles.module.scss';
import { useMediaQuery } from '@mantine/hooks';
import { apiInstance } from 'src/services';
import { useAppSelector } from 'src/store';
import { shallowEqual } from 'react-redux';
import { Lock } from '@geist-ui/icons';

const Footer: FC = () => {
  const isLargeDevice = useMediaQuery('(max-width: 1199px)');
  const [t] = useTranslation('nav');
  const [c] = useTranslation('common');
  
  const user = useAppSelector((state) => state.user.data, shallowEqual);

  // const hasPermission = user.userPermission?.includes('billing');
  const navigateToPayment = (): void => {
    // if(!hasPermission)
    //   {
    //       return;
    //   }
    apiInstance.get('payment/portal').then((res) => {
      window.open(res.data.url, '_blank');
    });
  };
  return (
    <Grid className={styles.footer} px={24} justify="flex-start" py={24} my={0} mx={0}>
      <Flex id="language-container" justify={isLargeDevice ? '' : 'space-between'}>
        <Flex
          w={isLargeDevice ? '100%' : 'auto'}
          direction={isLargeDevice ? 'row' : 'column'}
          justify={isLargeDevice ? 'space-between' : ''}>
          <Flex direction="column">
            <List className={styles.list}>
              {footerRoutes.map((route) => {
                return (
                  <List.Item key={route.path}>
                    {
                    // route.key === 'plan' ? (
                    //   <UnstyledButton
                    //     component="a"
                    //     tabIndex={0}
                    //     onClick={navigateToPayment}
                    //     aria-label={`${t(`${route.title}`)} ${c('opensInNewTabLink')}`}   
                    //     >
                    //     <Flex gap={'5px'}>
                    //               {/* { !hasPermission  && <Lock size={16} aria-label={`${t('lockedItem')}`} />} */}
                    //               {t(`${route.title}`)}
                    //     </Flex>   
                          
                        
                    //   </UnstyledButton>
                    // ) : (
                      <Link
                        aria-label={`${
                          route?.ariaLabel ? `${route.ariaLabel}` :
                            t(`${route.title}`)} ${route.blank ? c('opensInNewTabLink') : c('link')}
                          `}
                        to={route.path}

                        onClick={ () => {
                          const focusTarget = document.querySelector('#header_main') as HTMLDivElement;
                          if (focusTarget) {
                              focusTarget.setAttribute('tabindex', '-1');
                              focusTarget.focus();
                              focusTarget.removeAttribute('tabindex');
                          }
                        }}
                        target={route.blank ? '_blank' : '_self'}>
                        {t(`${route.title}`)}
                      </Link>
                    // )
                    }
                    <Space h={isLargeDevice ? 0 : 8} />
                  </List.Item>
                );
              })}
            </List>
          </Flex>
          <Flex pt={isLargeDevice ? 0 : 45} direction="column" justify={isLargeDevice ? 'space-between' : ''}>
            {!isLargeDevice && (
              <Text pb={10} id="contact">
                {t('contact')}:
              </Text>
            )}
            <Flex className={styles.icons}>
              {/* <UnstyledButton
                aria-label={`${t('followTwitter')} ${c('opensInNewTab')}`}
                px={10}
                component="a"
                href="https://twitter.com/Vially_io"
                target="_blank">
                <Twitter aria-hidden />
              </UnstyledButton> */}
              <UnstyledButton
                px={10}
                component="a"
                aria-label={`${t('followLinkedin')} ${c('opensInNewTab')}`}
                href="https://www.linkedin.com/company/inclusion-and-accessibility-labs/"
                target="_blank">
                <Linkedin aria-hidden />
              </UnstyledButton>
              <UnstyledButton
                aria-label={`${t('emailUs')} ${c('opensInNewTab')}`}
                component="a"
                href="mailto:hello@vially.io"
                target="_blank"
                px={10}>
                <MailTo aria-hidden />
              </UnstyledButton>
            </Flex>
            {/* {isLargeDevice && <SelectLanguage className={styles.languageFooter} />} */}
          </Flex>
        </Flex>
        {/* {!isLargeDevice && <SelectLanguage className={styles.languageFooter} />} */}
      </Flex>
    </Grid>
  );
};

export default Footer;
